import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { detectRole, getDefaultRoute, shouldRedirect } from '../utils/subdomainDetector';

const SubdomainRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const role = detectRole();
    const currentPath = location.pathname;
    
    // Only redirect on root path or if on wrong login page
    if (currentPath === '/' || shouldRedirect(currentPath, role)) {
      const defaultRoute = getDefaultRoute(role);
      
      // Only redirect if not already on correct route
      if (currentPath !== defaultRoute) {
        console.log(`🔄 Subdomain detected: ${role}, redirecting to ${defaultRoute}`);
        navigate(defaultRoute, { replace: true });
      }
    }
  }, [navigate, location]);

  return null; // This component doesn't render anything
};

export default SubdomainRedirect;
